module.exports = __webpack_public_path__ + "static/media/gif3.83324fe0.gif";